// removed by extract-text-webpack-plugin
module.exports = {"page":"LhTRYJ0VE _30W7J4cYZ gkmejKHip NYy_UUBwl FoW7vlZMf _1HeoWRlgs"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/promo-code-page/promo-code-page.css
 ** module id = 2194
 ** module chunks = 0
 **/